import { render } from "./DataShopBuy.vue?vue&type=template&id=436e4a81&scoped=true"
import script from "./DataShopBuy.vue?vue&type=script&lang=ts"
export * from "./DataShopBuy.vue?vue&type=script&lang=ts"

import "./DataShopBuy.vue?vue&type=style&index=0&id=436e4a81&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-436e4a81"

export default script